/**
 * Utility functions for UUID validation and handling
 */

import { v4 as uuidv4 } from 'uuid';

/**
 * Validates if a string is a valid UUID format
 */
export function isValidUUID(str: string): boolean {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}

/**
 * Validates if a user ID is valid for database operations
 * Returns an object with validation result and error message
 */
export function validateUserIdForDB(userId: string | undefined): { 
  isValid: boolean; 
  error?: string 
} {
  if (!userId) {
    return { isValid: false, error: "User ID is required" };
  }
  
  if (!isValidUUID(userId)) {
    return { 
      isValid: false, 
      error: "Invalid user ID format. Please sign in again to continue." 
    };
  }
  
  return { isValid: true };
}

/**
 * Generates a temporary local UUID for development/testing
 * This should not be used in production with real database operations
 */
export function generateLocalUUID(): string {
  return uuidv4();
}